import http from '@/utils/http';
import { SEARCH_HISTORY_TYPE } from '@home/_config/constant';
import { getQueryDefinition } from '@intelligence/services/common';

import type { IDBIAIPageAccessData } from '@home/types/home';

// 获取首页搜索下拉列表数据
export const fetchSearchPullDown: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/homepage/pc/searchPullDown',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

// 删除某个历史搜索记录
export const deleteHistory: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/homepage/pc/search/history/delete',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 查询字段搜索结果
export const fetchSearchResult: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    // url: '/api/v1/homepage/pc/searchList',
    url: '/api/v1/homepage/pc/searchNewListV2', // 新接口，不需要带上一次查询到的游戏ids,新版接口带pc&console
    // url: '/api/v1/homepage/pc/searchNewList', //新接口，不需要带上一次查询到的游戏ids
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 提供游戏ID获取游戏是否有舆情权限和数据
export const fetchGameListPermissions: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/opinion_pc/game/permissions',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 提供游戏ID获取游戏是否有经分权限和数据
export const fetchGameListDashboardPermissions: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/dashboard/game/permissions',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 添加历史查询记录
export const fetchAddSearchHistory: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/homepage/pc/search/history/add',
    method: 'post',
    data: {
      ...payload,
      search_type: payload?.search_type || SEARCH_HISTORY_TYPE.Game,
    },
    rawData: true,
  }) as Promise<any>;
};

// 搜索游戏选中详情-情报接口
export const getSearchCardIntelligence: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/homepage/pc/searchPreview',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 搜索游戏选中详情-舆情接口
export const getSearchCardOpinion: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/opinion_pc/global/search',
    method: 'post',
    data: payload,
    rawData: true,
    errorHandler: true,
  }) as Promise<any>;
};

// 查看是否收藏
export const fetchGameIfFollowing: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/collection/query',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 设置收藏|取消收藏
export const fetchGameSetFollowing: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/collection/create',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 设置搜索结果 点赞或点踩
export const fetchFeedbackSearchResult: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/homepage/pc/search/feedback',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 经分指标接口
export const getKeyPerformanceMetrics: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/dashboard/three_part_api/key_performance_metrics',
    method: 'post',
    data: payload,
    rawData: true,
    errorHandler: true,
  }) as Promise<any>;
};

// 获取搜索下拉热门游戏配置
export const fetchSearchTrendingConfig = async (): Promise<any[]> => {
  const result: any = await getQueryDefinition({
    search_trending: {
      target: 'search_trending',
      params: {},
    },
  });
  return Array.isArray(result?.data?.search_trending)
    ? result.data.search_trending
    : [];
};

// 获取搜索推荐信息
export const fetchSearchTrendings: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/homepage/pc/search/hot',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 搜索历史查询记录
export const fetchSearchHistories: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/homepage/pc/search/history',
    method: 'post',
    data: {
      ...payload,
      search_type: SEARCH_HISTORY_TYPE.Game,
    },
    rawData: true,
  }) as Promise<any>;
};

// 获取用户搜索下拉Trending状态是否展开
export const fetchUserSearchTrendingStatus: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/intelligence_pc/user/option',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export interface IFetchDBIAIPageAccessDataParams {
  keyword: string;
}

export const fetchDBIAIPageAccessData = async (
  data: IFetchDBIAIPageAccessDataParams,
): IBaseResponse<{ navigate: IDBIAIPageAccessData }> => {
  return http({
    url: '/api/v1/intelligence_pc/chatbi/navigate',
    method: 'post',
    data,
    rawData: true,
  }) as any;
};
